/**
 * @desc 供应商账号详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierAccountResponseDto>;
export function request(userNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierAccount/getInfo/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
